// extracted by mini-css-extract-plugin
export var banner = "_oy-0";
export var settingRow = "_oy-2";
export var titleIcon = "_oy-1";